import {
  useCreateImvChecklistDataMutation,
  useGetAllImvChecklistDataMutation,
  usePublishImvChecklistDataMutation,
  useUpdateImvChecklistDataMutation,
  useUploadDocumentMutation
} from 'src/services/IMVCheckList';

export const useIMVCheckListPage = () => {
  // const {
  //   data: imvCheckListData,
  //   error: imvCheckListDataError,
  //   isError: imvCheckListDataIsError,
  //   isLoading: imvCheckListLoading,
  //   refetch: getImvChecklistData
  // } = useGetimvChecklistDataQuery({
  //   site_id: selectedSite,
  //   study_id: studyId,
  //   country: selectedCountry,
  //   application: process.env.REACT_APP_NAME
  // });

  const [
    updateImvChecklistDataFn,
    {
      isLoading: updateImvChecklist,
      isSuccess: updateImvChecklistSuccess,
      data: updateImvCheckListData,
      isError: updateImvChecklistIsError,
      error: updateImvChecklistError
    }
  ] = useUpdateImvChecklistDataMutation();

  const [
    getAllImvChecklistData,
    {
      data: allImvChecklistData,
      error: allImvChecklistDataError,
      isError: allImvChecklistDataIsError,
      isLoading: allImvChecklistDataLoading,
      isSuccess: allImvChecklistDataIsSuccess
    }
  ] = useGetAllImvChecklistDataMutation();

  const [
    createImvChecklistDataFn,
    {
      isLoading: createImvChecklistLoading,
      isSuccess: createImvChecklistSuccess,
      data: createImvCheckListData,
      isError: createImvChecklistIsError,
      error: createImvChecklistError
    }
  ] = useCreateImvChecklistDataMutation();

  const [
    publishImvChecklistDataFn,
    {
      isLoading: publishImvChecklistLoading,
      isSuccess: publishImvChecklistSuccess,
      data: publishImvCheckListData,
      isError: publishImvChecklistIsError,
      error: publishImvChecklistError
    }
  ] = usePublishImvChecklistDataMutation();

  const [
    uploadDocument,
    {
      isLoading: uploadDocumentLoading,
      isSuccess: uploadDocumentSuccess,
      data: uploadDocumentData,
      isError: uploadDocumentIsError
    }
  ] = useUploadDocumentMutation();

  return {
    // imvCheckListData,
    // imvCheckListDataError,
    // imvCheckListDataIsError,
    // imvCheckListLoading,
    // getImvChecklistData,
    updateImvChecklist,
    updateImvChecklistSuccess,
    updateImvCheckListData,
    updateImvChecklistDataFn,
    updateImvChecklistIsError,
    updateImvChecklistError,
    createImvChecklistLoading,
    createImvChecklistSuccess,
    createImvCheckListData,
    createImvChecklistDataFn,
    createImvChecklistIsError,
    createImvChecklistError,
    allImvChecklistData,
    allImvChecklistDataError,
    allImvChecklistDataIsError,
    allImvChecklistDataIsSuccess,
    allImvChecklistDataLoading,
    getAllImvChecklistData,
    uploadDocument,
    uploadDocumentLoading,
    uploadDocumentSuccess,
    uploadDocumentData,
    uploadDocumentIsError,
    publishImvChecklistDataFn,
    publishImvChecklistLoading,
    publishImvChecklistSuccess,
    publishImvCheckListData,
    publishImvChecklistIsError,
    publishImvChecklistError
  };
};
